import { Grid, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { ERROR_MESSAGES, SUCCESS_MESSAGES } from '../../../../configs/messages';
import showMessage from '../../../../helpers/showMessage';
import { useSnackbar } from 'notistack';
import { sendJsonData } from '../../../../helpers/sendJsonData';
import { useParams } from 'react-router';
import { getDataList } from '../../../../helpers/getDataList';
import { LocalizationProvider, DesktopDatePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { differenceInCalendarDays } from 'date-fns';
import { format } from 'date-fns/esm';
import RemoveIcon from '@mui/icons-material/Remove';
import './programCreate.css';
import PageHeader from '../../includes/PageHeader';
import { ProgramFileUploadField } from '../../ProgramFile/ProgramFileUpload/ProgramFileUpload';
import locale from 'date-fns/locale/en-US';

const MaxDiffDay = 6;
const MinDiffDay = 1;

if (locale && locale.options) {
    locale.options.weekStartsOn = 1;
}

export function ProgramCreate() {
    const [errors, setErrors] = useState({});
    const [showFileForm, setShowFileForm] = useState(false);
    const [datepickerIsDisabled, setDatepickerIsDisabled] = useState(false);
    const [epgProgram, setEpgProgram] = useState('');
    const [initialData, setInitialData] = useState({
        broadcastWeek: '',
        startDate: null,
        endDate: null,
        channel: '',
        channelId: '',
    });

    const { enqueueSnackbar } = useSnackbar();

    const { channelId } = useParams();

    // let submitUrl = `program-list`;
    // if (isEdit) {
    //     submitUrl += `/${id}`;
    // }

    useEffect(() => {
        let isActive = true;
        const getData = async () => {
            try {
                const channelResponse = await getDataList(
                    `channel/role/${channelId}`,
                );
                const channel = channelResponse.data?.data;

                setInitialData((currentData) => ({
                    ...currentData,
                    channel,
                    channelId: channelId,
                }));
            } catch (error) {
                console.error(error);
                showMessage(
                    error.response?.data?.message
                        ? error.response.data.message
                        : ERROR_MESSAGES.REQUEST_FAIL,
                    enqueueSnackbar,
                    'error',
                );
            }
        };

        getData();

        return () => (isActive = false);
    }, []);

    const validate = () => {
        let tempErrors = { ...errors };
        const requiredMessage = ERROR_MESSAGES.FILL_THE_FIELD;

        if ('startDate' in initialData && 'endDate' in initialData) {
            tempErrors.endDate = initialData.endDate ? '' : requiredMessage;

            tempErrors.startDate = initialData.startDate ? '' : requiredMessage;

            let diff = differenceInCalendarDays(
                new Date(initialData.endDate),
                new Date(initialData.startDate),
            );

            if (diff >= MinDiffDay && diff <= MaxDiffDay) {
                const value =
                    format(initialData.startDate, 'yyyy/MM/dd') +
                    '-' +
                    format(initialData.endDate, 'yyyy/MM/dd');

                initialData.broadcastWeek = value;
            } else {
                tempErrors.endDate = 'error';
                tempErrors.startDate = 'error';
                showMessage(
                    ERROR_MESSAGES.NOT_MATCHED_DATE_RANGE,
                    enqueueSnackbar,
                    'error',
                );
            }
        }
        setErrors({
            ...tempErrors,
        });

        return tempErrors;
    };

    useEffect(() => {
        if (initialData.startDate && initialData.endDate) {
        //     sendRequest();
        const tempErrors = validate();

        for (const key in tempErrors) {
            if (tempErrors[key]) {
                showMessage(
                    ERROR_MESSAGES.FILL_THE_FORM,
                    enqueueSnackbar,
                    'error',
                );
                return;
            }
        }

        setShowFileForm(true);
        setDatepickerIsDisabled(true);
    }
    }, [initialData.startDate, initialData.endDate]);

    const handleDateChange = (date, name) => {
        setInitialData((prevData) => ({
            ...prevData,
            [name]: date,
        }));
    };

    const sendRequest = async () => {

        const requestBody = Object.assign({}, initialData);
        
        try {
            const response = await sendJsonData(requestBody, `program-list`)
            return response.data?.data.id
        } catch (error) {
            setShowFileForm(false);
            showMessage(
                error.response?.data?.message
                    ? error.response.data.message
                    : ERROR_MESSAGES.REQUEST_FAIL,
                enqueueSnackbar,
                'error',
            );
        }     
        
    };
    return (
        <>
            {/* <form autoComplete="false"> */}
            <Grid
                container
                direction="column"
                spacing={2}
                sx={{ width: '100%' }}
            >
                <Grid
                    item
                    container
                    spacing={2}
                    direction="column"
                    sx={{ width: '100%' }}
                >
                    <Grid item>
                        <div style={{ paddingLeft: '51px' }}>
                            <PageHeader
                                pageName={
                                    initialData.channel.name +
                                    `-н хөтөлбөр файлаар оруулах`
                                }
                                showAddNew={false}
                            />
                            <span
                                style={{
                                    display: 'inline-block',
                                    margin: '8px 8px 8px 0',
                                }}
                            >
                                <LocalizationProvider
                                    dateAdapter={AdapterDateFns}
                                    locale={locale}
                                >
                                    <DesktopDatePicker
                                        label="Эхлэх өдөр"
                                        inputFormat="yyyy/MM/dd"
                                        mask="____/__/__"
                                        value={initialData.startDate}
                                        disabled={datepickerIsDisabled}
                                        onChange={(newValue) => {
                                            handleDateChange(
                                                newValue,
                                                'startDate',
                                            );
                                        }}
                                        renderInput={(params) => (
                                            <TextField {...params} />
                                        )}
                                    />
                                    <RemoveIcon
                                        style={{ padding: '15px 5px' }}
                                    />
                                    <DesktopDatePicker
                                        label="Дуусах өдөр"
                                        inputFormat="yyyy/MM/dd"
                                        mask="____/__/__"
                                        value={initialData.endDate}
                                        disabled={datepickerIsDisabled}
                                        onChange={(newValue) => {
                                            handleDateChange(
                                                newValue,
                                                'endDate',
                                            );
                                        }}
                                        renderInput={(params) => (
                                            <TextField {...params} />
                                        )}
                                    />
                                </LocalizationProvider>
                            </span>
                        </div>
                        {showFileForm && (
                            <ProgramFileUploadField sendRequest={sendRequest} epgProgramId={epgProgram} />
                        )}
                    </Grid>

                    <Grid
                        item
                        container
                        direction="row"
                        justifyContent="space-between"
                        sx={{ mt: 2, ml: 6 }}
                    ></Grid>
                </Grid>
            </Grid>
            {/* </form> */}
        </>
    );
}
